export const options = [
  { label: "Now", value: "1" },
  { label: "Schedule Later", value: "2" },
];

export const serviceTime = [
  { value: "Morning (8AM-12PM)", match: "8,9,10,11,12", id: "1" },
  { value: "Afternoon (12PM-5PM)", match: "12,13,14,15,16,17", id: "2" },
  { value: "Evening (5PM-10PM)", match: "17,18,19,20,21,22", id: "3" },
  {
    value: "Night (10PM-7AM)",
    match: "22,23,00,01,02,03,04,05,06,07",
    id: "4",
  },
];

export const problemOptions = [
  { label: "Software", value: "Software" },
  { label: "Computer OS", value: "Computer Setup" },
  { label: "Smartwear-watch", value: "Smartwear watch" },
  {
    label: "Smartphone And Tablet Setup",
    value: "Smartphone And TabletSetup",
  },
  { label: "Printer / Scanner / Copiers", value: "Printer Scanner Copiers" },
  { label: "Server", value: "Server" },
  { label: "Email", value: "Email" },
  { label: "Internet", value: "Internet" },
  { label: "Website", value: "Website" },
  { label: "Device troubleshooting", value: "Device troubleshooting" },
];

export const subCategoryOptions = {
  Software: [
    "Microsoft Office Suite",
    "G-Doc",
    "Notepad",
    "Google Sheets",
    "Google Chrome",
    "Safari",
    "Firefox",
    "Adobe Photoshop",
    "CorelDraw",
    "AutoCAD",
    "Paintshop",
    "Skype",
    "Hangouts",
    "Google Meet",
    "Zoom",
    "Whatsapp",
    "Teams",
    "Google Classroom",
    "MX Player",
    "VLC Media Player",
    "Spotify",
    "Pandora Technologies",
    "Asana",
    "Zoho",
    "Slack",
    "Forecast",
    "Trello",
    "Airtable",
    "Oracle",
    "Digital Cameras",
    "IPad",
    "Samsung",
    "LG",
    "TV",
    "Bell",
    "Rogers",
  ],
  "Computer Setup": ["Windows", "Mac", "Chromebook"],
  "Smartphone And TabletSetup": ["Apple", "Android"],
  "Printer Scanner Copiers": ["Printer", "Scanner", "Copiers"],
  "Smartwear watch": ["Smartwear watch"],
  Server: ["Server"],
  Email: ["Email"],
  Internet: ["Internet"],
  Website: ["Website"],
  "Device troubleshooting": ["Device troubleshooting"],
  Others: ["Others"],
};

export const issuesInCategories = [
  { id: "Slow/Delayed", value: "Slow / Delayed" },
  { id: "Voicemail", value: "Voicemail" },
  { id: "Update Software", value: "Update Software" },
  { id: "Install Software", value: "Install Software" },
  { id: "Password/Login", value: "Password/Login" },
  { id: "Email", value: "Email" },
  { id: "WiFi connection", value: "WiFi connection" },
  { id: "Bluetooth Connection", value: "Bluetooth Connection" },
  { id: "Specific App Problem", value: "Specific App Problem" },
  { id: "Specific Software Problem", value: "Specific Software Problem" },
  { id: "Virus/Malware", value: "Virus / Malware" },
  { id: "Backup Issues", value: "Backup Issues" },
  { id: "File Restore", value: "File Restore" },
  { id: "Format", value: "Format" },
];

export const initialValues = {
  requestServiceType: "2",
  prefferedServiceTime: "",
  fromDateTime: "",
  toDateTime: "",
  categoriesOfProblems: "",
  requestServiceSkills: "",
  issuesInCategoriesSelected: "",
  serviceLanguage: [],
  serviceDescription: "",
};

export const languageOptions = [
  { id: "English", value: "English" },
  { id: "French", value: "Français (French)" },
  { id: "Deutsch", value: "Deutsch (German)" },
  { id: "Portugese", value: "Português (Portuguese)" },
  { id: "Mandarin", value: "普通话 (Mandarin)" },
  { id: "Cantonese", value: "粵語 (Yue/Cantonese)" },
  { id: "Spanish", value: "Español (Spanish)" },
  { id: "Tagalog", value: "Tagalog (Filipino)" },
  { id: "Russian", value: "Русский (Russian)" },
  { id: "Chinese", value: "中文 (Chinese)" },
  { id: "Korean", value: "한국어 (Korean)" },
  { id: "Persian", value: "فارسی (Persian)" },
  { id: "Italian", value: "Italiano (Italian)" },
  { id: "Vietnamese", value: "Tiếng Việt (Vietnamese)" },
  { id: "Dutch", value: "Nederlands (Dutch)" },
];

export const skillsOptions = [
  { id: "Windows", value: "Windows" },
  { id: "Chromebook", value: "Chromebook" },
  { id: "Mac", value: "Mac" },
  { id: "Apple", value: "Apple" },
  { id: "Android", value: "Android" },
  { id: "Printer", value: "Printer" },
  { id: "Scanner", value: "Scanner" },
  { id: "Copiers", value: "Copiers" },
  { id: "Smartwear - watch", value: "Smartwear - watch" },
  { id: "Server", value: "Server" },
  { id: "Email", value: "Email" },
  { id: "Internet", value: "Internet" },
  { id: "Website", value: "Website" },
  { id: "Device troubleshooting", value: "Device troubleshooting" },
  { id: "Microsoft Office Suite", value: "Microsoft Office Suite" },
  { id: "G-Doc", value: "G-Doc" },
  { id: "Notepad", value: "Notepad" },
  { id: "Google Sheets", value: "Google Sheets" },
  { id: "Browsers - Google Chrome", value: "Browsers - Google Chrome" },
  { id: "Safari", value: "Safari" },
  { id: "Firefox", value: "Firefox" },
  { id: "Graphics - Adobe Photoshop", value: "Graphics - Adobe Photoshop" },
  { id: "AutoCAD", value: "AutoCAD" },
  { id: "CorelDraw", value: "CorelDraw" },
  { id: "Paintshop", value: "Paintshop" },
  { id: "Communication - Skype", value: "Communication - Skype" },
  { id: "Hangouts", value: "Hangouts" },
  { id: "Google Meet", value: "Google Meet" },
  { id: "Zoom", value: "Zoom" },
  { id: "Whatsapp", value: "Whatsapp" },
  { id: "Teams", value: "Teams" },
  { id: "Google Classroom", value: "Google Classroom" },
  { id: "Multimedia - MX Player", value: "Multimedia - MX Player" },
  { id: "VLC Media Player", value: "VLC Media Player" },
  { id: "Spotify", value: "Spotify" },
  { id: "Pandora Technologies", value: "Pandora Technologies" },
  { id: "Project Management - Asana", value: "Project Management - Asana" },
  { id: "Zoho", value: "Zoho" },
  { id: "Slack", value: "Slack" },
  { id: "Forecast", value: "Forecast" },
  { id: "Trello", value: "Trello" },
  { id: "Airtable", value: "Airtable" },
  { id: "Database - Oracle", value: "Database - Oracle" },
  { id: "Digital Cameras", value: "Digital Cameras" },
  { id: "IPad", value: "IPad" },
  { id: "Samsung", value: "Samsung" },
  { id: "LG", value: "LG" },
  { id: "TV", value: "TV" },
  { id: "Bell", value: "Bell" },
  { id: "Rogers", value: "Rogers" },
];

export const eventColors = [
  "#2cdd9b",
  "#3498db",
  "#9b59b6",
  "#ffc107",
  "#56ccf2",
  "#f39c12",
  "#1abc9c",
  "#ff6b81",
];
